import HomeButton from './HomeButton'
import AboutButton from './AboutButton'

function Menu() {
  return (
    <div className="menu">
      <HomeButton  />
      <AboutButton  />
    </div>
  );
}

export default Menu
